var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14C0.5 6.26801 6.76801 0 14.5 0C22.232 0 28.5 6.26801 28.5 14C28.5 21.732 22.232 28 14.5 28C6.76801 28 0.5 21.732 0.5 14Z",
    fill: "#DCFAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4459 8.62096L12.0926 16.6826L9.87592 14.3143C9.46759 13.9293 8.82592 13.906 8.35925 14.2326C7.90425 14.571 7.77592 15.166 8.05592 15.6443L10.6809 19.9143C10.9376 20.311 11.3809 20.556 11.8826 20.556C12.3609 20.556 12.8159 20.311 13.0726 19.9143C13.4926 19.366 21.5076 9.81096 21.5076 9.81096C22.5576 8.73762 21.2859 7.79262 20.4459 8.60929V8.62096Z",
    fill: "#17B26A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturecheck);
export default __webpack_public_path__ + "static/media/featurecheck.35ada34e1eb7219f39ad1caebee6bf96.svg";
export { ForwardRef as ReactComponent };